import React from "react";
import PropTypes from "prop-types";
// import ActionDone from "material-ui/svg-icons/action/done";
import Done from "@material-ui/icons/Done";

const UploadStatusIcon = props => {
  const errorIcon = <span>Fail</span>;
  const successIcon = <Done />;

  if (props.file.hasUploaded && !props.file.isUploading) {
    if (props.file.errorsUploading) return errorIcon;
    return successIcon;
  }
  return <span>Not yet saved.</span>;
};
UploadStatusIcon.propTypes = {
  file: PropTypes.shape({
    errorsUploading: PropTypes.bool,
    isUploading: PropTypes.bool,
    hasUploaded: PropTypes.bool
  }).isRequired
};
export default UploadStatusIcon;
